import { Component, Inject, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { APP_CONFIG } from '../../../../app.config';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { ValidationService } from '../../../../common/validation.service';
import { AppConfig } from '../../../../models/config/app-config';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-erklaerung',
  templateUrl: './erklaerung.component.html',
  styleUrls: ['./erklaerung.component.scss']
})
export class ErklaerungComponent extends VisumErfassungSubFormComponent implements OnInit {


  constructor(fb: FormBuilder,
              protected validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl,
              @Inject(APP_CONFIG) public appConfig: AppConfig) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      vorbestraftJaNein: [null, validationService.getValidators('erklaerung.vorbestraft')],
      vorbestraftDeutschlandWann: [null, validationService.getValidators('erklaerung.strafeInDeutschland.wannUndWo')],
      vorbestraftDeutschlandGrund: [null, validationService.getValidators('erklaerung.strafeInDeutschland.grund')],
      vorbestraftDeutschlandHoehe: [null, validationService.getValidators('erklaerung.strafeInDeutschland.artUndHoeheDerStrafe')],
      vorbestraftAuslandWann: [null, validationService.getValidators('erklaerung.strafeImAusland.wannUndWo')],
      vorbestraftAuslandGrund: [null, validationService.getValidators('erklaerung.strafeImAusland.grund')],
      vorbestraftAuslandHoehe: [null, validationService.getValidators('erklaerung.strafeImAusland.artUndHoeheDerStrafe')],
      ausgewiesenJaNein: [null, validationService.getValidators('erklaerung.ausgewiesen')],
      ausgewiesenGrund: [null, validationService.getValidators('erklaerung.ausgewiesenAngaben')],
      krankJaNein: [null, validationService.getValidators('erklaerung.krankheiten')],
      krankInfos: [null, validationService.getValidators('erklaerung.krankheitenAngaben')]
    }));
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
